import { useEffect, useRef, useState } from 'react';
import { getApiErrorText } from '../../../../utils/apiResponse';

export default function useMobileMutation() {
  const mounted = useRef(false);
  const locked = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [warning, setWarning] = useState('');
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const run = async (operation, onSuccess) => {
    if (locked.current) return;
    locked.current = true;
    setBusy(true);
    setError('');
    setWarning('');
    try {
      const value = await operation();
      if (mounted.current && onSuccess) {
        try {
          await onSuccess(value);
        } catch (err) {
          if (mounted.current)
            setWarning('Зміни збережено, але не вдалося оновити відображення. Оновіть сторінку.');
        }
      }
    } catch (err) {
      if (mounted.current) setError(getApiErrorText(err, 'Не вдалося зберегти зміни'));
    } finally {
      locked.current = false;
      if (mounted.current) setBusy(false);
    }
  };
  return { busy, error: error || warning, setError, run, canClose: () => !locked.current };
}
